import { useEffect, useState } from 'react';

/** md breakpoint — matches the Tailwind `md:` switch (bottom nav → sidebar). */
const QUERY = '(min-width: 768px)';

/**
 * True at the `md` breakpoint and up. Used to pick the desktop popover vs. the
 * mobile bottom-sheet for the notification panel (and sheet-vs-dialog surfaces
 * generally), keeping the panel style in lockstep with which nav is showing.
 * Guards `matchMedia` so it is safe under jsdom / SSR (returns false when
 * unavailable).
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
